const BusinessTravel = () => {
    return (
        <div>
        <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

                <div className="px-1 flex flex-col justify-center">
                    <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                        Business Travel
                    </h1>
                    <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                        TCS provides one-stop travel solutions, whether it is individual or group business travel. 
                        We offer a wide variety of international and domestic travel related services, on all major 
                        domestic and international carriers. Value-added services such as consultancy, air-ticketing, 
                        hotel booking, concierge, travel insurance and visa facilitation are also provided.
                    </p>
                    
                </div>
                <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
                    <img src="/Intiana/image-2.jpg" alt="" className="rounded-md w-[100%]"/>
                    
                </div>
            </div>

        </div>

    </div>
    )
}
export default BusinessTravel;